import Renderer from '../Renderer';

/**
 * Wrapper for emitting logs to jellystone-frontend in a way that winston-transport can parse them.
 * Include the Exception object as "error" or "err" within additionalData to expose the stacktrace in Sentry.
 */
export default class logger {
  static warn(message, additionalData) {
    this.emitLog(Renderer.WARN, message, additionalData);
  }

  static error(message, additionalData) {
    this.emitLog(Renderer.ERROR, message, additionalData);
  }

  static info(message, additionalData) {
    this.emitLog(Renderer.INFO, message, additionalData);
  }

  static emitLog(logLevel, message, additionalData) {
    Renderer._instance.emit(logLevel, message, additionalData);
  }
}
